export default __webpack_public_path__ + "static/media/grid.022.0a364216.jpeg";